import { useLocale } from "../../i18n/LocaleContext";
import type { SiteLocale } from "../../i18n/locales";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobe } from "@fortawesome/free-solid-svg-icons";
import styles from "./LanguageSwitcher.module.scss";

interface LanguageSwitcherProps {
  className?: string;
  compact?: boolean;
  suppressHover?: boolean;
}

export function LanguageSwitcher({
  className,
  compact = false,
  suppressHover = false,
}: LanguageSwitcherProps) {
  const { locale, availableLocales, setLocale, isLocaleSwitching, t } = useLocale();

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newLocale = event.target.value as SiteLocale;
    if (isLocaleSwitching) {
      return;
    }
    setLocale(newLocale);
    event.target.blur();
  };

  const wrapperClassName = [
    styles.LanguageSwitcher,
    compact ? styles.Compact : "",
    suppressHover ? styles.SuppressHover : "",
    className ?? "",
  ]
    .filter(Boolean)
    .join(" ");

  const selectedLocale = availableLocales.find((entry) => entry.code === locale);
  const currentLabel = selectedLocale?.label ?? locale.toUpperCase();

  return (
    <div className={wrapperClassName}>
      <div className={styles.SelectWrapper}>
        <select
          value={locale}
          onChange={handleChange}
          className={styles.SelectOverlay}
          aria-label={t("language.select")}
          aria-busy={isLocaleSwitching}
          disabled={isLocaleSwitching}
        >
          {availableLocales.map(({ code, label }) => (
            <option key={code} value={code}>
              {label}
            </option>
          ))}
        </select>
        <div className={styles.ButtonBG} aria-hidden="true">
          <span className={styles.ButtonIcon}>
            <FontAwesomeIcon className={styles.Icon} icon={faGlobe} />
          </span>
          {!compact && <span className={styles.BtnText}>{currentLabel}</span>}
        </div>
      </div>
    </div>
  );
}

export default LanguageSwitcher;
